import { render, staticRenderFns } from "./ValueProposition.vue?vue&type=template&id=78e5057e"
import script from "./ValueProposition.vue?vue&type=script&lang=js"
export * from "./ValueProposition.vue?vue&type=script&lang=js"
import style0 from "./ValueProposition.vue?vue&type=style&index=0&id=78e5057e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports